import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { useWalletControllerContext } from 'hooks/useWalletControllerContext'
import { numberWithCommas } from 'utils/utils'

interface WalletTotalBalanceProps {
  isFetchingTotalBalance?: boolean
}

const WalletTotalBalance = ({ isFetchingTotalBalance }: WalletTotalBalanceProps) => {
  const { t } = useTranslation()

  const { totalBalance, baseCurrency, hasErrors } = useWalletControllerContext()
  const isLoadingTotalBalance = isFetchingTotalBalance

  return (
    <Box data-testid="wallets-total-balance">
      {!isLoadingTotalBalance ? (
        <>
          {!!totalBalance && !!baseCurrency && (
            <Box className="mb-2">
              <div className="text-body-regular text-foreground-subdued">{t('totalBalance')}</div>
              <h1 className="text-h1 text-foreground-prominent">
                {`${numberWithCommas(Number(totalBalance))} ${baseCurrency}`}
              </h1>
            </Box>
          )}
        </>
      ) : (
        <>
          {!hasErrors && (
            <Box className="rounded bg-surface-static animate-pulse h-10  w-2/5"></Box>
          )}
        </>
      )}
    </Box>
  )
}

export default WalletTotalBalance
